export const AiGenerationRating = {
  THUMBS_DOWN: 'THUMBS_DOWN',
  THUMBS_UP: 'THUMBS_UP'
};